import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

export default function ConfirmEmailChange() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: 'loading', message: '' });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/change-email/confirm`, { token: params.get('token') || '' })
      .then((r) => {
        localStorage.removeItem('token');
        setState({ status: 'ok', message: r.data.message });
      })
      .catch((e) => setState({ status: 'error', message: typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'This link is invalid or has expired.' }));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="bg-white border rounded-xl p-8 max-w-md w-full text-center space-y-4" data-testid="confirm-email-change-page">
        {state.status === 'loading' && <Loader2 className="h-8 w-8 animate-spin mx-auto" />}
        {state.status === 'ok' && <CheckCircle className="h-10 w-10 text-green-600 mx-auto" />}
        {state.status === 'error' && <XCircle className="h-10 w-10 text-red-600 mx-auto" />}
        <p className="text-gray-800" data-testid="confirm-email-change-message">{state.message || 'Confirming your new email…'}</p>
        {state.status !== 'loading' && (
          <Button onClick={() => navigate('/login')} data-testid="confirm-email-change-login">Go to sign in</Button>
        )}
      </div>
    </div>
  );
}
